import { properties } from "@repoflow/common/schema-fields";
import {
  email,
  orgId,
  domainId
} from "@common/schema/account/fields";

export default [
  {
    id: "/Public/Account/User",
    type: "object",
    properties: {
      ...properties,
      email,
      orgId,
      domainId
    },
  },

];
